import React from 'react';
import { LetterGradeBadge } from 'components/LetterGradeBadge/LetterGradeBadge';
import { ReactComponent as ChevronRight } from 'style/_assets/icons/chevron-right.svg';
import './FactorCards.scss';

function FactorCards({
  grade,
  factorTitle,
  datatestid,
  factorDescription,
  factorImpact,
  factorDifferential,
}) {
  return (
    <div
      className="FactorCards margB16 margR16"
      data-testid={datatestid ? `${datatestid}-factorCard` : null}
    >
      <div className="factorCardGrade">
        <LetterGradeBadge grade={grade} type="big" datatestid="factorGrade" />
      </div>

      <div
        className="FactorCardData"
        data-testid={datatestid ? `${datatestid}-dataCard` : null}
      >
        <div className="factorInfo">
          <div
            id={datatestid}
            className="factorDescription"
            data-testid={datatestid ? `${datatestid}-description` : null}
          >
            {factorDescription}
          </div>
          <div className="factorData">
            <div
              className="factorTitle"
              data-testid={datatestid ? `${datatestid}-title` : null}
            >
              {factorTitle}
            </div>
            {factorDifferential}
          </div>
        </div>

        <div
          className="factorImpact"
          data-testid={datatestid ? `${datatestid}-impact` : null}
        >
          <div>
            <ChevronRight aria-label="ChevronRight" />
          </div>
        </div>
      </div>
    </div>
  );
}

export { FactorCards };
